<template>
  <div class="wrp">
    <header style="padding: 0 16px;">
      <p style="font-weight:400;font-size: 16px" @click="back">返回</p>
      <p style="font-weight:600;font-size: 18px">个人中心</p>
      <p style="opacity: 0">返回</p>
    </header>
    <van-cell-group style="margin-top: 20px;">
      <van-cell title="管理员" :value="userInfo.name">
        <i style="color: #2196F3;margin-right:20px" slot="icon" class="basicmobilefont">&#xe6bd;</i>
      </van-cell>
      <van-cell title="手机号码" :value="userInfo.mobile">
        <i style="color: #2196F3;margin-right:20px" slot="icon" class="basicmobilefont">&#xe6ab;</i>
      </van-cell>
      <van-cell @click="logout" title="退出登录">
        <i style="color: #2196F3;margin-right:20px" slot="icon" class="basicmobilefont">&#xe6aa;</i>
      </van-cell>
    </van-cell-group>
    <Footer />
  </div>
</template>

<script>
import { CellGroup, Cell, Field, Button, Popup, Toast } from 'vant'
import { localStorage } from '@utils/basicUtil'
import Footer from '@components/OfficialAccount/Footer.vue'

export default {
  computed: {
    userInfo: (vm) => {
      return vm.$store.state.officialAccount.userInfo
    }
  },
  methods: {
    back () {
      this.$router.push('/official-account/manager')
    },
    logout () {
      localStorage.delete('login')
      localStorage.delete('user')
      this.$router.push('/official-account/login')
    }
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    Footer
  }
}
</script>

<style lang="less" scoped>
.wrp {
  width: 100%;
  height: 100%;
  overflow: hidden;
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    height: 80px;
    font-family: 'PingFang SC';
    color:rgba(51,51,51,1)
  }
}
</style>
